import validate from "/workspace/node_modules/.pnpm/nuxt@3.15.4_eslint@9.25.0_rollup@4.34.8_typescript@5.7.3_vite@6.1.0_vue-tsc@2.2.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import last_45visited_45page_45global from "/workspace/middleware/last-visited-page.global.ts";
import manifest_45route_45rule from "/workspace/node_modules/.pnpm/nuxt@3.15.4_eslint@9.25.0_rollup@4.34.8_typescript@5.7.3_vite@6.1.0_vue-tsc@2.2.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  last_45visited_45page_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "email-verify": () => import("/workspace/middleware/email-verify.ts"),
  auth: () => import("/workspace/node_modules/.pnpm/@sidebase+nuxt-auth@0.9.4_next-auth@4.21.1_typescript@5.7.3/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}